module.exports = __webpack_public_path__ + "img/logo.8d2c658e.svg";